
import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const AdmissionBoardServiceApi = createApi({
    reducerPath: 'AdmissionBoardServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAllAdmissionBoardApprovalList: builder.query({
            query: (details) => ({
                url: `/AdmissionBoard/GetAllAdmissionBoardApprovalList?id=${encryptAES(details.ipasMemberId)}&id2=${encryptAES(details.taskListId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendAdmissionBoardApproval: builder.mutation({
            query: (details) => ({
                url: `/AdmissionBoard/SendAdmissionBoardApproval`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        resendSendAdmissionBoardApprovalMail: builder.query({
            query: (details) => ({
                url: `/AdmissionBoard/ResendSendAdmissionBoardApprovalMail?id=${encryptAES(details.admissionBoardApprovalId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        admissionBoardDecisionToApprove: builder.mutation({
            query: (details) => ({
                url: `/AdmissionBoard/AdmissionBoardDecisionToApprove`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectAdmissionCommittee: builder.mutation({
            query: (details) => ({
                url: `/AdmissionBoard/RejectAdmissionCommittee`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        submitAdmissionBoardApproval: builder.mutation({
            query: (details) => ({
                url: `/AdmissionBoard/SubmitAdmissionBoardApproval`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        //Query to get All Admission Member List
        getAllManageAdmissionMemberList: builder.query({
            query: (details) => ({
                url: `/AdmissionBoard/GetAllManageAdmissionMemberList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addEditManageAdmissionMember: builder.mutation({
            query: (details) => ({
                url: '/AdmissionBoard/AddEditManageAdmissionMember',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteAdmissionCommitteeMemberById: builder.mutation({
            query: (details) => ({
                url: `/AdmissionBoard/DeleteAdmissionCommitteeMemberById?id=${encryptAES(details.id)}&id2=${encryptAES(details?.id2)}&id3=${encryptAES(details?.id3)}`,
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllManageAdmissionMemberById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/AdmissionBoard/GetAllManageAdmissionMemberById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCommitteeApprovalByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/AdmissionBoard/GetCommitteeApprovalByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        resetPasswordForWebMember: builder.mutation({
            query: (details) => ({
                url: '/Account/ResetPasswordForWebMember',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        ForgotPasswordMember: builder.mutation({
            query: (details) => ({
                url: '/Account/ForgotPasswordMemberforAdmin',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useLazyGetAllAdmissionBoardApprovalListQuery,
    useSendAdmissionBoardApprovalMutation,
    useLazyResendSendAdmissionBoardApprovalMailQuery,
    useAdmissionBoardDecisionToApproveMutation,
    useRejectAdmissionCommitteeMutation,
    useSubmitAdmissionBoardApprovalMutation,
    useLazyGetAllManageAdmissionMemberListQuery,
    useAddEditManageAdmissionMemberMutation,
    useDeleteAdmissionCommitteeMemberByIdMutation,
    useLazyGetAllManageAdmissionMemberByIdQuery,
    useLazyGetCommitteeApprovalByMemberIdQuery,
    useResetPasswordForWebMemberMutation,
    useForgotPasswordMemberMutation,


} = AdmissionBoardServiceApi;

export default AdmissionBoardServiceApi;